import mutations from './mutations'
import getters from './getters'
import actions from './actions'

export default {
  namespaced: true,
  state () {
    return {
      questions: [],
      practiceDetails: null,
    }
  },
  mutations: mutations,
  actions: actions,
  getters: getters
}
